"use client";

import  { useState, useEffect } from "react";
import { ShoppingCart, User2, Truck, LogOut, ChevronDown } from "lucide-react";
import SideCartV2 from "@/components/common/SideCartV2";
import { useAuth } from "@/packages/context/AuthContext";
import { useFastRouter } from "@/packages/hooks/useFastRouter";
import { useCart } from "@/packages/context/CartContext";
import CurrencySelectorV2 from "./CurrencySelectorV2";
import CountryCurrencySelector from "./CountryCurrencySelector";
import { HEADER_V2_DESIGN_SYSTEM } from "./designTokens";

export default function UserActionsV2() {

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const { isLoggedIn, logout, user } = useAuth();
  const isLoggedInState = mounted ? isLoggedIn : false;
  const { fastPush } = useFastRouter();
  const { cartItems, isCartOpen, setIsCartOpen } = useCart();

  const handleAuthNavigation = () => {
    if (isLoggedInState) {
      fastPush("/user-profile");
    } else {
      fastPush("/sign-in");
    }
  };

  const { colors, typography } = HEADER_V2_DESIGN_SYSTEM;

  return (


    <>
      <div className={`flex items-center gap-5 md:gap-[30px] ${colors.secondaryText} ${typography.fontFamilySans} text-sm font-semibold shrink-0`}>
        
        {/* NEW Country & Currency Combo Selector */}
        <CountryCurrencySelector className="hidden md:flex" />

        {/* Standalone Currency Selector (Hidden UI, URL & Context logic retained) */}
        <CurrencySelectorV2 className="!hidden" />




        {/* Store Location Finder */}


        {/* Shipping Policy link */}
        <button
          onClick={() => fastPush("/shipping-policy")}
          title="Shipping Policies"
          className="hidden md:flex items-center gap-1.5 hover:text-[var(--brand-accent)] transition-colors duration-200 cursor-pointer"
        >
          <Truck className="w-[16px] h-[16px] text-slate-500" />
          <span className="hidden md:inline text-xs font-semibold">
            Shipping
          </span>
        </button>

        {/* Account login/profile */}
        {isLoggedInState ? (
          <div className="relative group hidden md:block">
            <button
              onClick={handleAuthNavigation}
              title="Profile"
              className="flex items-center gap-1.5 hover:text-[var(--brand-accent)] transition-colors duration-200 cursor-pointer py-1"
            >
              <User2 className="w-[16px] h-[16px] text-slate-500" />
              <span className="hidden md:inline text-xs font-semibold">
                Profile
              </span>
              <ChevronDown className="w-3 h-3 text-slate-400 group-hover:text-[var(--brand-accent)] transition-transform duration-200 group-hover:rotate-180" />
            </button>

            {/* Hover Dropdown Menu */}
            <div className="absolute right-0 top-full pt-1.5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-[100] min-w-[160px]">
              <div className="bg-white rounded-xl shadow-xl border border-slate-100 py-1.5 text-slate-700 overflow-hidden">
                {user?.email && (
                  <div className="px-3.5 py-1.5 border-b border-slate-100 font-medium text-[11px] text-slate-400 truncate">
                    {user.email}
                  </div>
                )}
                <button
                  onClick={() => fastPush("/user-profile")}
                  className="w-full flex items-center gap-2 px-3.5 py-2 text-xs font-semibold hover:bg-slate-50 hover:text-[var(--brand-accent)] transition-colors text-left cursor-pointer"
                >
                  <User2 className="w-4 h-4 text-slate-500" />
                  <span>Orders</span>
                </button>
                <button
                  onClick={() => logout()}
                  className="w-full flex items-center gap-2 px-3.5 py-2 text-xs font-semibold text-rose-600 hover:bg-rose-50 transition-colors text-left border-t border-slate-100 cursor-pointer"
                >
                  <LogOut className="w-4 h-4 text-rose-500" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <button
            onClick={handleAuthNavigation}
            title="Sign in"
            className="hidden md:flex items-center gap-1.5 hover:text-[var(--brand-accent)] transition-colors duration-200 cursor-pointer"
          >
            <User2 className="w-[16px] h-[16px] text-slate-500" />
            <span className="hidden md:inline text-xs font-semibold">
              Login
            </span>
          </button>
        )}


        <button
          onClick={() => setIsCartOpen(true)}
          title="Shopping cart"
          className="relative flex items-center gap-2.5 text-slate-700 hover:text-[var(--brand-accent)] transition-colors duration-200 cursor-pointer"
        >
          <div className="relative pr-1">
            <ShoppingCart className="w-[23px] h-[23px] stroke-[1.8] text-current" />
            <span className="absolute top-[-4px] right-[0px] inline-flex h-[15px] min-w-[15px] items-center justify-center rounded-full bg-[var(--brand-accent)] px-1 text-[8px] font-bold text-white shadow-xs">
              {mounted ? cartItems.length : 0}
            </span>
          </div>
          <span className="hidden md:inline text-[13px] font-semibold text-current">Cart</span>
        </button>

      </div>

      {/* Side Cart Drawer Wrapper */}
      {isCartOpen && (
        <div
          className="fixed inset-0 z-[999] bg-black/40 backdrop-blur-xs transition-opacity duration-300"
          onClick={() => setIsCartOpen(false)}
        >
          <div
            className="fixed top-0 right-0 h-full w-full sm:w-[400px] bg-white shadow-2xl z-[1000] transform transition-transform duration-300 translate-x-0"
            onClick={(e) => e.stopPropagation()}
          >
            <SideCartV2 onClose={() => setIsCartOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
}
